$(function () {

  /* Remove empty paragraphs
  ---------------------------------- */
  $('p:empty').remove();

  /* Style image-card siblings
  ---------------------------------- */
  var myA;
  var opener;
  var closer
  $('.js-images').each(function() {
    if(!$(this).prev().hasClass('js-images')) {
      opener = $(this).prev();
    }
    if(!$(this).next().hasClass('js-images')) {
      closer = $(this).next();
    }

    if(opener && closer) {
      var wrapper = document.createElement('figure');
      wrapper.className = 'images';
      opener.nextUntil(closer).wrapAll(wrapper);
      opener = undefined;
      closer = undefined;
    }
  });


  /* Style image-card siblings
  ---------------------------------- */
  var myA;
  var opener;
  var closer
  $('.js-verweis').each(function() {
    if(!$(this).prev().hasClass('js-verweis')) {
      opener = $(this).prev();
    }
    if(!$(this).next().hasClass('js-verweis')) {
      closer = $(this).next();
    }

    if(opener && closer) {
      var wrapper = document.createElement('div');
      wrapper.className = 'verweise';
      opener.nextUntil(closer).wrapAll(wrapper);
      opener = undefined;
      closer = undefined;
    }
  });

  /* Style image-card siblings
  ---------------------------------- */
  var myA;
  var opener;
  var closer
  $('.js-tab').each(function() {
    if(!$(this).prev().hasClass('js-tab')) {
      opener = $(this).prev();
    }
    if(!$(this).next().hasClass('js-tab')) {
      closer = $(this).next();
    }

    if(opener && closer) {
      var wrapper = document.createElement('div');
      wrapper.className = 'tabs';
      opener.nextUntil(closer).wrapAll(wrapper);
      opener = undefined;
      closer = undefined;
    }
  });

  /* Style quote siblings
  ---------------------------------- */
  var myA;
  var opener;
  var closer
  $('.js-youtube').each(function() {
    if(!$(this).prev().hasClass('js-youtube')) {
      opener = $(this).prev();
    }
    if(!$(this).next().hasClass('js-youtube')) {
      closer = $(this).next();
    }

    if(opener && closer) {
      var wrapper = document.createElement('div');
      wrapper.className = 'youtubes';
      opener.nextUntil(closer).wrapAll(wrapper);
      opener = undefined;
      closer = undefined;
    }
  });


  /**
   * @summary Dropdown navigation
   *
   * @namespace none (closure)
   * @codekeeper Fernando
   * @since Version 0.1
   ************************************/
  $('.navtrigger').click(function() {
    if ($('.navtrigger').hasClass('close')) {
      $('.navtrigger').removeClass('close');
    } else {
      $('.navtrigger').addClass('close');
    }

    if ($('.navigation').hasClass('isInvisible')) {
      $('.navigation').addClass('visible').removeClass('isInvisible');
    } else {
      $('.navigation').removeClass('visible').addClass('isInvisible');
    }
  });

  $('.js-search-trigger')
    .on('click', function(e) {
      e.preventDefault();
      var x = ($(window).width() - ($(this).offset().left + $(this).width())) + 'px';
      var y = ($(this).offset().top - $(document).scrollTop() + $(this).outerHeight(true)) + 'px';

      $('.js-search-trigger a').addClass('isActive');
      $('.js-navigation-search').removeClass('isInvisibleFromTablet').addClass('visible');
      $('.js-navigation-search').css('top', y).css('right', x);
      $('.js-search-field').focus();
    });

  $('.js-navigation-search')
    .on('mouseleave', function(e) {
      $('.js-search-trigger a').removeClass('isActive');
      $('.js-navigation-search').removeClass('visible').addClass('isInvisibleFromTablet');
    });

    /**
     * @summary stickybutton
     *
     * @namespace none (closure)
     * @codekeeper agentur mcs > Fernando
     * @since Version 0.1
     ************************************/
    window.addEventListener('scroll', function(e) {
      var bheight = window.innerHeight / 1.5;
      var stickyButton = document.querySelector('.stickybutton');
      var body = document.body;
      var breadcrumbs = document.querySelector('.breadcrumb');

      function toggleVisibility(el, show = false) {
        el.style.position = 'fixed';
        
        if(show) {
          el.style.bottom = '0px';
        } else {
          el.style.bottom = '-20%';
        }
      }

      function isScrolledIntoView(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        // The element is in view if its top is above the viewport bottom,
        // regardless of whether it's fully visible or the user has scrolled past it.
        var isVisible = (elemTop <= window.innerHeight);
        
        return isVisible;
      }

      // Check for scroll position – special trigger for "Leistungen" LP
      if(stickyButton) {
        if(body.classList.contains('leistungen') && breadcrumbs) {
          var breadcrumbReached = isScrolledIntoView(breadcrumbs);
          if(breadcrumbReached && stickyButton.style.bottom !== '0px') {
            toggleVisibility(stickyButton, true);
          }
          if(!breadcrumbReached && stickyButton.style.bottom === '0px') {
            toggleVisibility(stickyButton, false);
          }
        } else {
          var scrollTop = window.scrollY || document.documentElement.scrollTop;

          if(scrollTop > bheight && stickyButton.style.bottom !== '0px') {
            toggleVisibility(stickyButton, true);
          }
          if (scrollTop < bheight && stickyButton.style.bottom === '0px') {
            toggleVisibility(stickyButton, false);
          }
        }
      }
    });

  /**
   * @summary gets the viewport width
   * on page load or window resize
   * for usage on other methods.
   *
   * @namespace none (closure)
   * @codekeeper agentur mcs > Fernando
   * @since Version 0.1
   ************************************/
  window.getWidth = function() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  }


    /**
     * @summary Scroll-Down navigation
     *
     * @namespace none (closure)
     * @codekeeper Fernando
     * @since Version 0.1
     ************************************/
     $('.js-scroll-trigger').click(function(e) {
       e.preventDefault();
       var link = $(e.target).attr('href');
       var distance = 0;
       $('html, body').animate({ scrollTop: ($(link).offset().top - distance) });
     });

     /**
    * @summary lightbox closer trigger
    *
    * @namespace none (closure)
    * @codekeeper agentur mcs > Fernando
    * @since Version 0.1
    ************************************/
    $('.js-video-play').click(function(e) {
      e.preventDefault();

      let source = $('.js-lightbox-video .lightbox-video-dummy');
      let video = '<iframe class="lightbox-video js-lightbox-video" src="//www.youtube-nocookie.com/embed/EjdqxkR8xEo?autoplay=1&wmode=opaque&border=0&showinfo=0&autoplay=1&rel=0&modestbranding=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>';
      source.replaceWith(video);

      $('.js-lightbox-video').removeClass('isInvisible');
    });

    /**
     * @summary lightbox closer trigger
     *
     * @namespace none (closure)
     * @codekeeper agentur mcs > Fernando
     * @since Version 0.1
     ************************************/
     $('.js-calculator-show').click(function(e) {
       e.preventDefault();

       let source = $('.js-lightbox-calculator .lightbox-calculator-dummy');
       let iframe = '<iframe id="vorteilsrechner-embed" class="iframe" src="https://www.ikkbb.de/versicherte/mitglied-werden/leistungs-und-vorteilsrechner?view=iframe"></iframe>';
       source.replaceWith(iframe);

       $('.js-lightbox-calculator').removeClass('isInvisible');
       $('body').addClass('hasNoScrolling');
     });

     /**
      * @summary lightbox closer trigger
      *
      * @namespace none (closure)
      * @codekeeper agentur mcs > Fernando
      * @since Version 0.1
      ************************************/
      $('.js-legal-show').click(function(e) {
        e.preventDefault();
        $('.js-lightbox-legal').removeClass('isInvisible');
        $('body').addClass('hasNoScrolling');
      });

     /**
      * @summary lightbox closer trigger
      *
      * @namespace none (closure)
      * @codekeeper agentur mcs > Fernando
      * @since Version 0.1
      ************************************/
      $('.js-contact-show').click(function(e) {
        e.preventDefault();
        $('.js-lightbox-contact').removeClass('isInvisible');
      });

     /**
    * @summary lightbox closer trigger
    *
    * @namespace none (closure)
    * @codekeeper agentur mcs > Fernando
    * @since Version 0.1
    ************************************/
    $('.js-lightbox-close').click(function(e) {
      e.preventDefault();
      $(e.target).closest('.js-lightbox-close').addClass('isInvisible');
      
      let videoIframe = $('iframe.js-lightbox-video');
      if(videoIframe.length > 0) {
        videoIframe.parent().html('<div class="lightbox-close"></div><div class="lightbox-video-dummy"></div>');
      }
      
      // $('iframe.js-lightbox-video').attr('src', $('iframe.js-lightbox-video').attr('src'));
      $('.navtrigger.close').click();
      $('body').removeClass('hasNoScrolling');
    });

    /**
     * @summary logic for the accordion
     * element.
     *
     ************************************/
     $(function() {
       var allPanels = $('.js-tab > .js-tab-content').hide();
       $('.js-tab > .js-tab-title').click(function() {
         $(this).next().slideToggle('fast');
         var $el = $(this);
         if($el.hasClass('isOpen')) {
           $el.removeClass('isOpen');
         } else {
           $el.addClass('isOpen');
         }
         return false;
       });
     });


   /**
    * @summary initialize the slick
    * plugin for the slider.
    *
    * @namespace none (closure)
    * @codekeeper agentur mcs > Fernando
    * @since Version 0.1
    ***********************************/
    $(window).on('load', function() {
      $('.js-copyright').html(new Date().getFullYear());
    });

  /**
   * 
   * @namespace none (closure)
   * @codekeeper agentur mcs > Fernando
   * @since Version 0.1
   ***********************************/
    $(window).on('load', function() {
      $('.js-iframe-afterload').each(function() {
        var that = $(this);
        var data_scr = that.attr('data-src');

        setTimeout(function() {
          if(typeof _paq !== 'undefined') {
            // Add Matomo's cross domain tracking parameter to iFrame source
            var crossDomainQueryParam;
            _paq.push([
              function() {
               crossDomainQueryParam = this.getCrossDomainLinkingUrlParameter();
              }
            ]);

            if (data_scr.includes('?')) {
              // Append new parameter
              data_scr += '&' + crossDomainQueryParam;
            } else {
              // Add Parameter in first place
              data_scr += '?' + crossDomainQueryParam;
            } 
          }

          that.attr('src', data_scr);
        }, 2000);
      });
    });

  /**
   * @summary initialize the slick
   * plugin for the slider.
   *
   * @namespace none (closure)
   * @codekeeper agentur mcs > Fernando
   * @since Version 0.1
   ***********************************/
  $(function() {
    try {
      $('.js-gallery').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    } catch (e) {
      console.log('slick pluggin not available.');
    }
   });


   /* Equalize heights
   ----------------------------------*/
   var equializeHeight = function() {
     for (i = 0; i < arguments.length; i++) {
       var currentTallest = 0,
         currentRowStart = 0,
         rowDivs = new Array(),
         $el,
         topPosition = 0;
       $(arguments[i]).each(function() {
         $el = $(this);
         topPosition = $el.position().top;
         if (currentRowStart != topPosition) {
           // we just came to a new row.  Set all the heights on the completed row
           for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
             rowDivs[currentDiv].css("min-height", function(){ return currentTallest });
           }
           // set the variables for the new row
           rowDivs.length = 0; // empty the array
           currentRowStart = topPosition;
           currentTallest = $el.height();
           rowDivs.push($el);
         } else {
           rowDivs.push($el);
           currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
         }

         // do the last row
         for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].css("min-height", function(){ return currentTallest });
         }
       });
     }
   };
   var automatizeHeight = function() {
     for (i = 0; i < arguments.length; i++) {
       var currentTallest = 0,
         currentRowStart = 0,
         rowDivs = new Array(),
         $el,
         topPosition = 0;
       $(arguments[i]).each(function() {
         $el = $(this);
         topPosition = $el.position().top;

         if (currentRowStart != topPosition) {
           // we just came to a new row.  Set all the heights on the completed row
           for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
             rowDivs[currentDiv].css("min-height", "auto");
           }
           // set the variables for the new row
           rowDivs.length = 0; // empty the array
           currentRowStart = topPosition;
           currentTallest = $el.height();
           rowDivs.push($el);
         } else {
           // another div on the current row.  Add it to the list and check if it's taller
           rowDivs.push($el);
           currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
         }
         // do the last row
         for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
           rowDivs[currentDiv].css("min-height", "auto");
         }
       });
     }
   };

   $(window).on('load resize', function() {
     if(window.getWidth() > 767) {
       equializeHeight('.js-card', '.js-card-title', '.js-card-description', '.js-subnavigation-title');
     } else {
       automatizeHeight('.js-card', '.js-card-title', '.js-card-description', '.js-subnavigation-title');
     }
   });

   $(function() {
     $('.js-contact-button').click(function(e) {
       /* prevent Email from bubbling up */
       e.preventDefault();
       /* validate form */
       var containsCharacters = $('#email').val().indexOf('@') !== -1 && $('#email').val().indexOf('.') !== -1 ? true : false;
       if ($('#email').val() === "" || !containsCharacters || $('#nachricht').val() === undefined || $('#vorname').val() === undefined || $('#nachname').val() === undefined) {
         alert('Bitte füllen Sie alle Felder korrekt aus.');
         $(this).addClass('isWrong');
         return false;
       }
       /* show the spining arrow */
       $(this).html('').removeClass('isWrong').addClass('isLoading').css('pointer-events', 'none');

       /* pipulate the mail values */
       var firstname = encodeURIComponent($('#vorname').val());
       var lastname = encodeURIComponent($('#nachname').val());
       var email = $('#email').val();
       var message = encodeURIComponent($('#nachricht').val());
       var contact = $(this).data('contact');
       var data = "&email=" + email + "&firstname=" + firstname + "&lastname=" + lastname + "&message=" + message + "&contact=" + contact;
       var that = this;
       /* call send mail script */
       jQuery.ajax({
         type: "POST",
         url: location.protocol + '//' + location.host + "/_assets/scripts/contact.php",
         data: data,
         success: function() {
           alert("Ihre Anfrage wurde erfolgreich versendet. Vielen Dank.");
           $(that).removeClass('isLoading').addClass('isOk');
         },
         error: function(errormessage) {
           alert("Ihre Anfrage konnte nicht abgeschlossen werden. Versuchen Sie es bitte später erneut. Vielen Dank.");
           console.log(errormessage);
         }
       });
     });
    });
});
